import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import { image } from '../Basurl/Baseurl'
import { GetUserData } from '../reducer/userSlice'
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import { EdituserData } from '../reducer/userSlice'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { hospitalContactYup, handleContactNumberChange } from "../utils/phoneValidation";
export default function EditProfile() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const dispatch = useDispatch()
  const { getuser, loading, error } = useSelector((state) => state.getuser)
  console.log(getuser)
  useEffect(() => {
    dispatch(GetUserData());
  }, [dispatch]);
  useEffect(() => {
    console.log(error, getuser);
  }, [error, getuser]);


  const basicSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .min(2, 'Name must be at least 2 characters')
      .max(50, 'Name cannot exceed 50 characters'),
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
    phone_no: hospitalContactYup(true),
    gender: Yup.string()
      .oneOf(['Male', 'Female', 'Others'], 'Invalid gender selection')
      .required('Gender is required'),
    profileImage: Yup.mixed(),
    password: Yup.string()
      .transform((value) => (value === '' ? undefined : value))
      .min(6, 'Password must be at least 6 characters')
      .notRequired(),
    confirmPassword: Yup.string().when('password', {
      is: (password) => Boolean(password),
      then: (schema) =>
        schema
          .required('Confirm password is required')
          .oneOf([Yup.ref('password')], 'Passwords must match'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row gx-3">
            <div className="col-md-12">
              <div className="topmainhd">
                <h6>
                  <i
                    class="fa-solid fa-arrow-left-long me-2"
                    onClick={() => window.history.back()}
                  ></i>
                  Edit Profile
                </h6>
              </div>
            </div>
            <div className="col-md-12">
              <div className="main_content">
                <Formik
                  enableReinitialize
                  initialValues={{
                    name: getuser?.name || "",
                    email: getuser?.email || "",
                    phone_no: getuser?.phone_no || "",
                    gender: getuser?.gender || "",
                    profileImage: getuser?.profileImage || null,
                    password: "",
                    confirmPassword: "",
                  }}
                  validationSchema={basicSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const payload = {
                        id: getuser._id,
                        name: values.name,
                        email: values.email,
                        phone_no: values.phone_no,
                        gender: values.gender,
                      };
                      if (values.profileImage instanceof File) {
                        payload.profileImage = values.profileImage;
                      }
                      if (values.password) {
                        payload.password = values.password;
                        if (values.confirmPassword) {
                          payload.confirmPassword = values.confirmPassword;
                        }
                      }

                      const result = await dispatch(
                        EdituserData(payload)
                      ).unwrap();

                      Swal.fire("Success!", "Profile updated successfully.", "success");
                      navigate('/Admin/profile')
                    } catch (err) {
                      alert(err)
                      Swal.fire("Error!", err?.message || "An error occurred", "error");
                    }
                    setSubmitting(false);
                  }}
                >
                  {({ isSubmitting, setFieldValue, values }) => (
                    <Form>
                      <div className="row">
                        <div className='col-md-12'>
                          <div className="profile-img-wrap">
                            {selectedImage ? (
                              <img
                                className="avatar"
                                src={URL.createObjectURL(selectedImage)}
                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                              />
                            ) : getuser?.profileImage ? (
                              <img
                                className="avatar"
                                src={`${image}${getuser.profileImage}`}
                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                              />
                            ) : (
                              <img
                                className="avatar"
                                src="assets/img/user.jpg"
                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                              />
                            )}

                            <div className="fileupload btn">
                              <span className="btn-text"><i class="fa fa-camera" aria-hidden="true"></i></span>
                              <input
                                type="file"
                                className="upload"
                                onChange={(event) => {
                                  setFieldValue("profileImage", event.target.files[0]);
                                  setSelectedImage(event.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="field-set">
                            <label className="focus-label">Name<span className="text-danger">*</span></label>
                            <Field type="text" className="form-control floating" name="name" />
                          </div>
                          <ErrorMessage name="name" component="div" style={{ color: "red" }} />
                        </div>
                        <div className="col-md-6">
                          <div className="field-set">
                            <label className="focus-label">Email<span className="text-danger">*</span></label>
                            <Field type="email" className="form-control floating" name="email" />
                            <ErrorMessage name="email" component="div" style={{ color: "red" }} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="field-set">
                            <label className="focus-label">Phone No<span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              className="form-control floating"
                              name="phone_no"
                              onChange={(e) =>
                                handleContactNumberChange(
                                  e,
                                  setFieldValue,
                                  "phone_no",
                                )
                              }
                            />
                            <ErrorMessage name="phone_no" component="div" style={{ color: "red" }} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="field-set">
                            <label className="focus-label">Gender<span className="text-danger">*</span></label>
                            <Field as="select" className="form-control floating" name="gender">
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Others">Others</option>
                            </Field>
                            <ErrorMessage name="gender" component="div" style={{ color: "red" }} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="field-set">
                            <label className="focus-label">New Password</label>
                            <Field
                              type="password"
                              className="form-control floating"
                              name="password"
                              placeholder="Leave blank to keep current password"
                              autoComplete="new-password"
                            />
                            <ErrorMessage name="password" component="div" style={{ color: "red" }} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="field-set">
                            <label className="focus-label">Confirm Password</label>
                            <Field
                              type="password"
                              className="form-control floating"
                              name="confirmPassword"
                              placeholder="Re-enter new password"
                              autoComplete="new-password"
                            />
                            <ErrorMessage name="confirmPassword" component="div" style={{ color: "red" }} />
                          </div>
                        </div>
                        <div className="">
                          <button
                            className="submit-btn"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}